var map = {
	"./decidim/avatar-multiuser.png": 88002,
	"./decidim/brands/facebook.svg": 19924,
	"./decidim/brands/google.svg": 21933,
	"./decidim/brands/twitter-x.svg": 91326,
	"./decidim/cc-badge.png": 16540,
	"./decidim/decidim-logo.svg": 60176,
	"./decidim/default-avatar.svg": 76488,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 79988,
	"./decidim/icons.svg": 53795,
	"./decidim/pattern.png": 26004,
	"./decidim/placeholder-card-g.svg": 33377,
	"./decidim/placeholder-card-l.svg": 33642,
	"./decidim/placeholder.jpg": 69945,
	"./decidim/remixicon.symbol.svg": 30829,
	"./decidim/vendor/social-share-button/douban.svg": 93692,
	"./decidim/vendor/social-share-button/email.svg": 55257,
	"./decidim/vendor/social-share-button/facebook.svg": 3247,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 43761,
	"./decidim/vendor/social-share-button/hacker_news.svg": 95929,
	"./decidim/vendor/social-share-button/linkedin.svg": 3673,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 86010,
	"./decidim/vendor/social-share-button/pinterest.svg": 33759,
	"./decidim/vendor/social-share-button/reddit.svg": 75811,
	"./decidim/vendor/social-share-button/telegram.svg": 39318,
	"./decidim/vendor/social-share-button/tumblr.svg": 69397,
	"./decidim/vendor/social-share-button/twitter.svg": 3464,
	"./decidim/vendor/social-share-button/vkontakte.svg": 55622,
	"./decidim/vendor/social-share-button/wechat.svg": 23745,
	"./decidim/vendor/social-share-button/whatsapp.svg": 25225,
	"./decidim/vendor/social-share-button/x.svg": 3169,
	"./decidim/vendor/social-share-button/xing.svg": 70415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54717;